import React from 'react';
import { css } from "@emotion/core";
import { ClipLoader } from 'react-spinners';

const override = css`
display: block;
margin: 0 auto;
border-color: red;
`;

const Loader = (props) => (
  <div style={{position: "fixed", top: "50%", left: "50%"}}>
    <ClipLoader 
      css={override}
      size={60}
    />
  </div>
)

export default Loader;


// WEBPACK FOOTER //
// ./src/views/Loader.js